<template>
	<div
		class="product-image-holder"
		:class="{ sold: isSold, 'has-image': imageUrl, 'has-no-image': !imageUrl }"
	>
		<v-lazy-image
			v-if="imageUrl"
			class="product-image"
			alt=""
			:src="imageUrl"
			:src-placeholder="placeholderUrl"
		/>
		<div class="product-image-badge-holder">
			<slot name="sold-badge" />
			<slot name="cart" />
		</div>
	</div>
</template>

<script>
import VLazyImage from 'v-lazy-image/v2'

export default {
	name: 'ProductImage',

	components: {
		VLazyImage
	},

	props: {
		imageUrl: {
			type: String,
			default: ''
		},
		placeholderUrl: {
			type: String,
			default: ''
		},

		isSold: Boolean
	}
}
</script>

<style lang="scss">
.product-image-holder {
	float: right;
	width: 104px;
	height: 104px;
	border-radius: 8px;
	overflow: hidden;
	background: #2e2b36 url('../assets/images/placeholder_beverage.svg') no-repeat
		50%;
	position: relative;
}

.product-image-badge-holder {
	position: absolute;
	left: 50%;
	bottom: 6px;
	text-align: center;
	transform: translateX(-50%);
	z-index: 20;
}

.product-image {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
</style>
